import {
  BoxGeometry,
  EdgesGeometry,
  Group,
  LineBasicMaterial,
  LineSegments,
  Mesh,
  MeshBasicMaterial,
} from 'three';
import type { RegionDefinition } from '../types';

export function createRegionHighlight(region: RegionDefinition): Group {
  const root = new Group();
  root.name = `region-${region.id}`;
  root.position.set(...region.center);
  const geometry = new BoxGeometry(0.094, 0.018, 0.046);
  const fill = new Mesh(
    geometry,
    new MeshBasicMaterial({ color: region.accent, transparent: true, opacity: 0, depthWrite: false }),
  );
  fill.userData = { kind: 'region', region: region.id };
  const edges = new LineSegments(
    new EdgesGeometry(geometry),
    new LineBasicMaterial({ color: region.accent, transparent: true, opacity: 0.28 }),
  );
  edges.userData = { kind: 'region', region: region.id };
  root.add(fill, edges);
  return root;
}

export function setRegionActive(root: Group, active: boolean): void {
  const fill = root.children[0] as Mesh;
  const edges = root.children[1] as LineSegments;
  (fill.material as MeshBasicMaterial).opacity = active ? 0.07 : 0;
  (edges.material as LineBasicMaterial).opacity = active ? 0.95 : 0.22;
}
